// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.wapper-toppbar {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  background-color: var(--color-bg);
  width: 100%;
  box-sizing: border-box;
  font-family: "Pretendard", sans-serif;
  transition: background-color var(--duration-base) var(--easing-standard);
}
.wapper-toppbar .wapper {
  display: flex;
  align-items: center;
  margin-right: 20px; /* 로고와 네비게이션 사이의 간격 */
}
.wapper-toppbar .wapper-right {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}
.wapper-toppbar .wapper__img {
  height: 36px;
  width: auto;
}
.wapper-toppbar .navbar {
  display: flex;
  align-items: center;
  /* 역삼각형 아이콘 */
  /* Report 메뉴에 대한 호버 처리 */
}
.wapper-toppbar .navbar__item {
  position: relative;
  padding: 0 20px;
  cursor: pointer;
  font-weight: 500;
  font-size: 20px;
  color: var(--color-text-muted);
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.3s ease;
  font-family: "Pretendard", sans-serif;
}
.wapper-toppbar .navbar__item:hover {
  color: #1890ff;
}
.wapper-toppbar .navbar__item.active {
  color: #1890ff;
}
.wapper-toppbar .navbar__item.active:after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 20px;
  transform: none;
  width: calc(100% - 40px);
  height: 3px;
  background-color: #1890ff;
  border-radius: 2px;
}
.wapper-toppbar .navbar__item.active, .wapper-toppbar .navbar__item[class*=active] {
  color: #1890ff;
}
.wapper-toppbar .navbar__item.active:after, .wapper-toppbar .navbar__item[class*=active]:after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 20px;
  transform: none;
  width: calc(100% - 40px);
  height: 3px;
  background-color: #1890ff;
  border-radius: 2px;
}
.wapper-toppbar .navbar__item.has-submenu:hover .navbar__submenu {
  display: block;
}
.wapper-toppbar .navbar__arrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid currentColor;
  margin-top: 2px;
}
.wapper-toppbar .navbar__submenu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 180px;
  background-color: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  display: none;
  z-index: var(--z-dropdown);
  padding: var(--sp-2);
}
.wapper-toppbar .navbar__submenu-item {
  padding: 10px var(--sp-3);
  color: var(--color-text-muted);
  cursor: pointer;
  transition: background var(--duration-base) var(--easing-standard), color var(--duration-base) var(--easing-standard);
  white-space: nowrap;
  font-size: 16px;
  border-radius: var(--radius-md);
  margin: 2px 0;
  font-family: "Pretendard", sans-serif;
}
.wapper-toppbar .navbar__submenu-item:hover {
  background-color: var(--color-bg-subtle);
  color: var(--color-text);
}
.wapper-toppbar .navbar__submenu-item.active {
  background: linear-gradient(90deg, rgba(14, 165, 233, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%);
  color: var(--color-text);
  font-weight: var(--fw-semibold);
}
.wapper-toppbar .navbar__submenu-item[style*="cursor: not-allowed"] {
  opacity: 0.5;
  color: #666 !important;
}
.wapper-toppbar .navbar__submenu-item[style*="cursor: not-allowed"]:hover {
  background-color: transparent;
  color: #666 !important;
}
.wapper-toppbar .navbar__submenu-item[style*="cursor: not-allowed"].active {
  color: #1890ff !important;
}
.wapper-toppbar .navbar .navbar__item:hover .navbar__submenu {
  display: block;
}
.wapper-toppbar .wapper__username {
  font-size: 20px;
  color: var(--color-text-muted);
  font-weight: 500;
  margin-left: 0;
  padding: 0 20px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: "Pretendard", sans-serif;
  text-decoration: none !important;
  border-bottom: none !important;
  /* Profile 메뉴에 대한 호버 처리 */
}
.wapper-toppbar .wapper__username span {
  color: var(--color-text-muted);
  transition: color var(--duration-base) var(--easing-standard);
  font-family: "Pretendard", sans-serif;
  text-decoration: none !important;
  border-bottom: none !important;
}
.wapper-toppbar .wapper__username:hover {
  color: #1890ff;
  text-decoration: none !important;
}
.wapper-toppbar .wapper__username:hover span {
  color: #1890ff;
  text-decoration: none !important;
}
.wapper-toppbar .wapper__username.active {
  color: #1890ff;
  text-decoration: none !important;
  border-bottom: none !important;
}
.wapper-toppbar .wapper__username.active span {
  color: #1890ff !important;
  text-decoration: none !important;
}
.wapper-toppbar .wapper__username.active:after {
  display: none; /* 밑줄 가상 요소를 숨김 */
}
.wapper-toppbar .wapper__username.has-submenu:hover .profile__submenu {
  display: block;
}
.wapper-toppbar .wapper__username:hover .profile__submenu {
  display: block;
}
.wapper-toppbar .wapper__username .profile__submenu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 180px;
  background-color: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  display: none;
  z-index: var(--z-dropdown);
  padding: var(--sp-2);
}
.wapper-toppbar .wapper__username .profile__submenu::before {
  content: "";
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  height: 12px;
}
.wapper-toppbar .wapper__username .profile__submenu.visible {
  display: block;
}
.wapper-toppbar .wapper__username .profile__submenu-item {
  padding: 10px var(--sp-3);
  color: var(--color-text-muted);
  cursor: pointer;
  white-space: nowrap;
  font-size: 16px;
  font-weight: var(--fw-medium);
  background-color: transparent;
  border-radius: var(--radius-md);
  margin: 2px 0;
  font-family: "Pretendard", sans-serif;
  transition: background var(--duration-base) var(--easing-standard), color var(--duration-base) var(--easing-standard);
}
.wapper-toppbar .wapper__username .profile__submenu-item:hover {
  background-color: var(--color-bg-subtle);
  color: var(--color-text);
}
.wapper-toppbar .wapper__username .profile__submenu-item.active {
  background: linear-gradient(90deg, rgba(14, 165, 233, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%);
  color: var(--color-text);
  font-weight: var(--fw-semibold);
}
.wapper-toppbar .profile__submenu-item.active ~ .wapper__username,
.wapper-toppbar .profile__submenu-item.active + .wapper__username {
  color: #1890ff;
}
.wapper-toppbar .profile__submenu-item.active ~ .wapper__username span,
.wapper-toppbar .profile__submenu-item.active + .wapper__username span {
  color: #1890ff !important;
}
.wapper-toppbar .profile__submenu-item.active ~ .wapper__username:after,
.wapper-toppbar .profile__submenu-item.active + .wapper__username:after {
  display: none; /* 밑줄 가상 요소를 숨김 */
}

.profile__submenu-item {
  padding: 10px var(--sp-3);
  cursor: pointer;
  border-radius: var(--radius-md);
  font-family: "Pretendard", sans-serif;
  color: var(--color-text-muted);
  font-size: 16px;
  font-weight: var(--fw-medium);
  transition: background var(--duration-base) var(--easing-standard), color var(--duration-base) var(--easing-standard);
}
.profile__submenu-item:hover {
  background-color: var(--color-bg-subtle);
  color: var(--color-text);
}
.profile__submenu-item.active {
  background: linear-gradient(90deg, rgba(14, 165, 233, 0.1) 0%, rgba(139, 92, 246, 0.1) 100%);
  color: var(--color-text);
  font-weight: var(--fw-semibold);
}`, "",{"version":3,"sources":["webpack://./src/component/ui/Navigator/component/NaviBar.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EAEA,iCAAA;EACA,WAAA;EACA,sBAAA;EACA,qCAAA;EACA,wEAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA,EAAA,qBAAA;AADJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAHJ;AAME;EAGE,YAAA;EACA,WAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;EA4DA,aAAA;EAmEA,wBAAA;AApIJ;AAOI;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,qCAAA;AALN;AAOM;EACE,cAAA;AALR;AAQM;EACE,cAAA;AANR;AAQQ;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,wBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AANV;AAUM;EACE,cAAA;AARR;AAUQ;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,wBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AARV;AAcU;EACE,cAAA;AAZZ;AAmBI;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,kCAAA;EACA,eAAA;AAjBN;AAoBI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,gBAAA;EACA,iCAAA;EACA,qCAAA;EACA,+BAAA;EACA,4BAAA;EACA,aAAA;EACA,0BAAA;EACA,oBAAA;AAlBN;AAoBM;EACE,yBAAA;EACA,8BAAA;EACA,eAAA;EACA,qHAAA;EAEA,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,aAAA;EACA,qCAAA;AAnBR;AAqBQ;EACE,wCAAA;EACA,wBAAA;AAnBV;AAsBQ;EACE,4FAAA;EAKA,wBAAA;EACA,+BAAA;AAxBV;AA2BQ;EACE,YAAA;EACA,sBAAA;AAzBV;AA2BU;EACE,6BAAA;EACA,sBAAA;AAzBZ;AA4BU;EACE,yBAAA;AA1BZ;AAiCI;EACE,cAAA;AA/BN;AAmCE;EACE,eAAA;EAEA,8BAAA;EACA,gBAAA;EAGA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,qCAAA;EACA,gCAAA;EACA,8BAAA;EA2CA,yBAAA;AA9EJ;AAqCI;EACE,8BAAA;EACA,6DAAA;EACA,qCAAA;EACA,gCAAA;EACA,8BAAA;AAnCN;AAsCI;EACE,cAAA;EACA,gCAAA;AApCN;AAsCM;EACE,cAAA;EACA,gCAAA;AApCR;AAwCI;EACE,cAAA;EACA,gCAAA;EACA,8BAAA;AAtCN;AAwCM;EACE,yBAAA;EACA,gCAAA;AAtCR;AAyCM;EACE,aAAA,EAAA,iBAAA;AAvCR;AA6CQ;EACE,cAAA;AA3CV;AAiDI;EACE,cAAA;AA/CN;AAoDI;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;EACA,iCAAA;EACA,qCAAA;EACA,+BAAA;EACA,4BAAA;EACA,aAAA;EACA,0BAAA;EACA,oBAAA;AAlDN;AAsDM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AApDR;AAuDM;EACE,cAAA;AArDR;AAwDM;EACE,yBAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,6BAAA;EACA,+BAAA;EACA,aAAA;EACA,qCAAA;EACA,qHAAA;AAtDR;AAyDQ;EACE,wCAAA;EACA,wBAAA;AAvDV;AA0DQ;EACE,4FAAA;EAKA,wBAAA;EACA,+BAAA;AA5DV;AAmEE;;EAEE,cAAA;AAjEJ;AAmEI;;EACE,yBAAA;AAhEN;AAmEI;;EACE,aAAA,EAAA,iBAAA;AAhEN;;AAwEA;EACE,yBAAA;EACA,eAAA;EACA,+BAAA;EACA,qCAAA;EACA,8BAAA;EACA,eAAA;EACA,6BAAA;EACA,qHAAA;AArEF;AAwEE;EACE,wCAAA;EACA,wBAAA;AAtEJ;AAyEE;EACE,4FAAA;EAKA,wBAAA;EACA,+BAAA;AA3EJ","sourcesContent":["// Pretendard @font-face moved to src/styles/global.scss (single source).\n\n.wapper-toppbar {\n  display: flex;\n  align-items: center;\n  height: 60px;\n  padding: 0 20px;\n  // Tokenized so dark mode (data-theme=\"dark\") swaps the chrome automatically.\n  background-color: var(--color-bg);\n  width: 100%;\n  box-sizing: border-box;\n  font-family: 'Pretendard', sans-serif;\n  transition: background-color var(--duration-base) var(--easing-standard);\n\n  .wapper {\n    display: flex;\n    align-items: center;\n    margin-right: 20px; /* 로고와 네비게이션 사이의 간격 */\n  }\n\n  // Right-side cluster (theme toggle + profile dropdown).\n  .wapper-right {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-left: auto;\n  }\n\n  .wapper__img {\n    // Height fixed, width auto so the PNG keeps its native aspect ratio.\n    // Same values used in GuestNaviBar so the brand mark is identical across layouts.\n    height: 36px;\n    width: auto;\n  }\n\n  .navbar {\n    display: flex;\n    align-items: center;\n\n    &__item {\n      position: relative;\n      padding: 0 20px;\n      cursor: pointer;\n      font-weight: 500;\n      font-size: 20px;\n      color: var(--color-text-muted);\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      transition: all 0.3s ease;\n      font-family: 'Pretendard', sans-serif;\n\n      &:hover {\n        color: #1890ff;\n      }\n\n      &.active {\n        color: #1890ff;\n        \n        &:after {\n          content: '';\n          position: absolute;\n          bottom: -5px;\n          left: 20px;\n          transform: none;\n          width: calc(100% - 40px);\n          height: 3px;\n          background-color: #1890ff;\n          border-radius: 2px;\n        }\n      }\n\n      &.active, &[class*=\"active\"] {\n        color: #1890ff;\n        \n        &:after {\n          content: '';\n          position: absolute;\n          bottom: -5px;\n          left: 20px;\n          transform: none;\n          width: calc(100% - 40px);\n          height: 3px;\n          background-color: #1890ff;\n          border-radius: 2px;\n        }\n      }\n\n      &.has-submenu {\n        &:hover {\n          .navbar__submenu {\n            display: block;\n          }\n        }\n      }\n    }\n\n    /* 역삼각형 아이콘 */\n    &__arrow {\n      display: inline-block;\n      width: 0;\n      height: 0;\n      border-left: 5px solid transparent;\n      border-right: 5px solid transparent;\n      border-top: 5px solid currentColor;\n      margin-top: 2px;\n    }\n\n    &__submenu {\n      position: absolute;\n      top: 100%;  // 부모 요소 바로 아래에 위치\n      left: 0;\n      min-width: 180px;\n      background-color: var(--color-bg);\n      border: 1px solid var(--color-border);\n      border-radius: var(--radius-lg);\n      box-shadow: var(--shadow-xl);\n      display: none;\n      z-index: var(--z-dropdown);\n      padding: var(--sp-2);\n\n      &-item {\n        padding: 10px var(--sp-3);\n        color: var(--color-text-muted);\n        cursor: pointer;\n        transition: background var(--duration-base) var(--easing-standard),\n                    color var(--duration-base) var(--easing-standard);\n        white-space: nowrap;\n        font-size: 16px;\n        border-radius: var(--radius-md);\n        margin: 2px 0;\n        font-family: 'Pretendard', sans-serif;\n\n        &:hover {\n          background-color: var(--color-bg-subtle);\n          color: var(--color-text);\n        }\n\n        &.active {\n          background: linear-gradient(\n            90deg,\n            rgba(14, 165, 233, 0.10) 0%,\n            rgba(139, 92, 246, 0.10) 100%\n          );\n          color: var(--color-text);\n          font-weight: var(--fw-semibold);\n        }\n\n        &[style*=\"cursor: not-allowed\"] {\n          opacity: 0.5;\n          color: #666 !important;\n          \n          &:hover {\n            background-color: transparent;\n            color: #666 !important;\n          }\n\n          &.active {\n            color: #1890ff !important;\n          }\n        }\n      }\n    }\n\n    /* Report 메뉴에 대한 호버 처리 */\n    .navbar__item:hover .navbar__submenu {\n      display: block;\n    }\n  }\n\n  .wapper__username {\n    font-size: 20px;\n    // Tokenized so it stays readable in both light and dark.\n    color: var(--color-text-muted);\n    font-weight: 500;\n    // margin-left: auto was needed when this lived directly under .wapper-toppbar.\n    // Now it's inside .wapper-right, which already handles right-alignment via gap.\n    margin-left: 0;\n    padding: 0 20px;\n    cursor: pointer;\n    position: relative;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    font-family: 'Pretendard', sans-serif;\n    text-decoration: none !important;\n    border-bottom: none !important;\n\n    span {\n      color: var(--color-text-muted);\n      transition: color var(--duration-base) var(--easing-standard);\n      font-family: 'Pretendard', sans-serif;\n      text-decoration: none !important;\n      border-bottom: none !important;\n    }\n\n    &:hover {\n      color: #1890ff;\n      text-decoration: none !important;\n      \n      span {\n        color: #1890ff;\n        text-decoration: none !important;\n      }\n    }\n\n    &.active {\n      color: #1890ff;\n      text-decoration: none !important;\n      border-bottom: none !important;\n      \n      span {\n        color: #1890ff !important;\n        text-decoration: none !important;\n      }\n\n      &:after {\n        display: none; /* 밑줄 가상 요소를 숨김 */\n      }\n    }\n\n    &.has-submenu {\n      &:hover {\n        .profile__submenu {\n          display: block;\n        }\n      }\n    }\n\n    /* Profile 메뉴에 대한 호버 처리 */\n    &:hover .profile__submenu {\n      display: block;\n    }\n\n    // Profile dropdown — tokenized to match the sidebar floating submenu\n    // (soft border, large radius, xl shadow, light hover, gradient active).\n    .profile__submenu {\n      position: absolute;\n      top: calc(100% + 6px);\n      right: 0;\n      min-width: 180px;\n      background-color: var(--color-bg);\n      border: 1px solid var(--color-border);\n      border-radius: var(--radius-lg);\n      box-shadow: var(--shadow-xl);\n      display: none;\n      z-index: var(--z-dropdown);\n      padding: var(--sp-2);\n\n      // Invisible hover-bridge covering the 6px gap to the username trigger,\n      // so the mouse can travel down without dropping :hover.\n      &::before {\n        content: '';\n        position: absolute;\n        top: -10px;\n        left: 0;\n        right: 0;\n        height: 12px;\n      }\n\n      &.visible {\n        display: block;\n      }\n\n      &-item {\n        padding: 10px var(--sp-3);\n        color: var(--color-text-muted);\n        cursor: pointer;\n        white-space: nowrap;\n        font-size: 16px;\n        font-weight: var(--fw-medium);\n        background-color: transparent;\n        border-radius: var(--radius-md);\n        margin: 2px 0;\n        font-family: 'Pretendard', sans-serif;\n        transition: background var(--duration-base) var(--easing-standard),\n                    color var(--duration-base) var(--easing-standard);\n\n        &:hover {\n          background-color: var(--color-bg-subtle);\n          color: var(--color-text);\n        }\n\n        &.active {\n          background: linear-gradient(\n            90deg,\n            rgba(14, 165, 233, 0.10) 0%,\n            rgba(139, 92, 246, 0.10) 100%\n          );\n          color: var(--color-text);\n          font-weight: var(--fw-semibold);\n        }\n      }\n    }\n  }\n\n  // 별도의 선택자로 추가\n  .profile__submenu-item.active ~ .wapper__username,\n  .profile__submenu-item.active + .wapper__username {\n    color: #1890ff;\n\n    span {\n      color: #1890ff !important;\n    }\n\n    &:after {\n      display: none; /* 밑줄 가상 요소를 숨김 */\n    }\n  }\n}\n\n// Unscoped fallback (some markup paths render .profile__submenu-item outside the\n// .wapper-toppbar parent). Mirrors the tokenized active style above so both\n// paths render identically with the new light palette.\n.profile__submenu-item {\n  padding: 10px var(--sp-3);\n  cursor: pointer;\n  border-radius: var(--radius-md);\n  font-family: 'Pretendard', sans-serif;\n  color: var(--color-text-muted);\n  font-size: 16px;\n  font-weight: var(--fw-medium);\n  transition: background var(--duration-base) var(--easing-standard),\n              color var(--duration-base) var(--easing-standard);\n\n  &:hover {\n    background-color: var(--color-bg-subtle);\n    color: var(--color-text);\n  }\n\n  &.active {\n    background: linear-gradient(\n      90deg,\n      rgba(14, 165, 233, 0.10) 0%,\n      rgba(139, 92, 246, 0.10) 100%\n    );\n    color: var(--color-text);\n    font-weight: var(--fw-semibold);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
